<template>
  <button v-if="type === 'button'" @click.prevent="$emit('buttonClick')" class="button-secondary" :class="[disabled ? 'button-secondary--disabled': null, fullWidth ? 'button-secondary--full-width' : null, theme ? 'button-secondary--' + theme : null]">
    {{ title }}
  </button>
  <a v-else-if="type === 'link'" :href="link" class="button-secondary" :class="{'button-secondary--disabled': disabled, 'button-secondary--full-width': fullWidth}">
    {{ title }}
  </a>
  <router-link v-else-if="type === 'router'" :to="link" class="button-secondary" :class="{'button-secondary--disabled': disabled, 'button-secondary--full-width': fullWidth}">
    {{ title }}
  </router-link>
</template>

<script>

export default {
  name: 'ButtonSecondary',
  data: () => ({
  }),
  components: {
  },
  computed: {
  },
  props: {
    title: { type: String , required: true, default: null },
    disabled: { type: Boolean , required: false, default: false },
    fullWidth: { type: Boolean , required: false, default: false },
    link: { type: String , required: false, default: null },
    type: { type: String , required: false, default: 'button' }, // button / link / router
    theme: { type: String , required: false, default: null }, // docusign
  },
  mounted () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.button-secondary {
    width: auto;
    background: $white;
    border: 1px solid $grey-9c;
    color: $grey;
    height: 47px;
    padding: 10px 15px;
    min-width: 122px;
    @include responsive-text-size('Button--12--BOLD');
    border-radius: 4px;
    @include ease-fast;
    text-align: center;
    display: inline-flex;
    align-items: center;
    text-align: center;
    justify-content: center;

    &.button-secondary--full-width {
      width: 100%;
    }

    &:hover {
      background: $divider-dark;
      color: $white;    
    }

    &:disabled, &.button-secondary--disabled {
      background: $divider-dark;
      color: $white;
      pointer-events: none;
    }

    &:focus:not(.focus-hidden) {
      background: $divider-dark;
      color: $grey-9c;
    }


}
</style>
